import React, { createContext, useState } from "react";

interface PublicCreateActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;  
  element: any;
  setElement: (element: any) => void;  
}

export const PublicCreateActionContext = createContext<PublicCreateActionContextType>({  
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  element: null,
  setElement: () => {},  
});

interface PublicCreateActionProviderProps {
  children: React.ReactNode;
}

export const PublicCreateActionProvider: React.FC<PublicCreateActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<any>(null);  

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,    
  };
  return (
    <PublicCreateActionContext.Provider value={value}>
      {children}
    </PublicCreateActionContext.Provider>
  );
};
